import { render, staticRenderFns } from "./OeesCriticos.vue?vue&type=template&id=5c8696bc&"
import script from "./OeesCriticos.vue?vue&type=script&lang=js&"
export * from "./OeesCriticos.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports